/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Text, ArrowLeft, Icon, View } from '@az/starc-ui'
import { NavLink } from 'react-router-dom'

export const NavigationBackButton = () => {
  return (
    <NavLink to="/" className="qa-Link-Back">
      <View direction="row" align="center">
        <Icon svg={ArrowLeft} size={7} color="accent" />
        <View.Item gapBefore={3}>
          <Text variant="button">BACK</Text>
        </View.Item>
      </View>
    </NavLink>
  )
}
